import { createReducer } from "@reduxjs/toolkit";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import type { RequestState } from "@redux/state/shared-types";
import { enrollStudentToBatch, resetEnrollStudentToBatch } from "./enroll-student-to-batch";

export type EnrollmentKind = "newStudent" | "studentId";

export interface EnrollStudentToBatchState {
  processing: RequestState;
  enrollmentKind: Nullable<EnrollmentKind>;
}

const initialState: EnrollStudentToBatchState = { processing: "idle", enrollmentKind: null };

export const enrollStudentToBatchReducer = createReducer<EnrollStudentToBatchState>(initialState, builder => {
  builder.addCase(enrollStudentToBatch.pending, (state, action) => ({
    ...state,
    processing: "pending",
    enrollmentKind: action.meta.arg.studentId ? "studentId" : "newStudent",
  }));
  builder.addCase(enrollStudentToBatch.fulfilled, state => ({
    ...state,
    processing: "success",
  }));
  builder.addCase(enrollStudentToBatch.rejected, state => ({
    ...state,
    processing: "failed",
  }));
  builder.addCase(resetEnrollStudentToBatch, () => initialState);
});
